export default {
  GET_GRAPH_DATA: (state) => state.graphData,
};
